import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
export function InvitePopup({ onClose, onUploadImage, onUploadVideo, onShareScreen, onAddCamera, onAddMicrophone, onInviteSpeakers, onAddRemoteCamera, onAddOgrafGraphic, }) {
    return (_jsxs(PopupRoot, { children: [_jsxs(PopupItem, { onClick: () => {
                    onShareScreen?.();
                    onClose();
                }, children: [_jsx(PopupItemBg, {}), _jsxs(PopupItemContent, { children: [_jsx(ScreenShareIcon, {}), _jsx("span", { children: "Share screen" })] })] }), _jsxs(PopupItem, { onClick: () => {
                    onAddCamera?.();
                }, children: [_jsx(PopupItemBg, {}), _jsxs(PopupItemContent, { children: [_jsx(CameraIcon, {}), _jsx("span", { children: "Add camera" })] })] }), _jsxs(PopupItem, { onClick: () => {
                    onAddMicrophone?.();
                }, children: [_jsx(PopupItemBg, {}), _jsxs(PopupItemContent, { children: [_jsx(MicrophoneIcon, {}), _jsx("span", { children: "Add microphone" })] })] }), _jsxs(PopupItem, { onClick: () => {
                    onUploadImage?.();
                    onClose();
                }, children: [_jsx(PopupItemBg, {}), _jsxs(PopupItemContent, { children: [_jsx(ImageIcon, {}), _jsx("span", { children: "Upload Image" })] })] }), _jsxs(PopupItem, { onClick: () => {
                    onUploadVideo?.();
                    onClose();
                }, children: [_jsx(PopupItemBg, {}), _jsxs(PopupItemContent, { children: [_jsx(VideoIcon, {}), _jsx("span", { children: "Upload Video" })] })] }), _jsxs(PopupItem, { onClick: () => {
                    onInviteSpeakers?.();
                    onClose();
                }, children: [_jsx(PopupItemBg, {}), _jsxs(PopupItemContent, { children: [_jsx(InviteIcon, {}), _jsx("span", { children: "Invite speakers" })] })] }), onAddRemoteCamera && (_jsxs(PopupItem, { onClick: () => {
                    onAddRemoteCamera();
                    onClose();
                }, children: [_jsx(PopupItemBg, {}), _jsxs(PopupItemContent, { children: [_jsx(RemoteCameraIcon, {}), _jsx("span", { children: "Add remote camera" })] })] })), onAddOgrafGraphic && (_jsxs(PopupItem, { onClick: () => {
                    onAddOgrafGraphic();
                    onClose();
                }, children: [_jsx(PopupItemBg, {}), _jsxs(PopupItemContent, { children: [_jsx(OgrafIcon, {}), _jsx("span", { children: "Add OGraf graphic" })] })] }))] }));
}
function ImageIcon() {
    return (_jsxs("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Upload image", children: [_jsx("rect", { x: "2", y: "4", width: "16", height: "12", rx: "2", stroke: "currentColor", strokeWidth: "1.5" }), _jsx("circle", { cx: "7", cy: "8", r: "1.5", fill: "currentColor" }), _jsx("path", { d: "M2 13l4.5-4 3.5 3 2.5-2L18 14", stroke: "currentColor", strokeWidth: "1.5", strokeLinejoin: "round" })] }));
}
function VideoIcon() {
    return (_jsxs("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Upload video", children: [_jsx("rect", { x: "2", y: "4", width: "16", height: "12", rx: "2", stroke: "currentColor", strokeWidth: "1.5" }), _jsx("path", { d: "M8.5 7.5v5l4-2.5-4-2.5z", fill: "currentColor" })] }));
}
function CameraIcon() {
    return (_jsxs("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Add camera", children: [_jsx("rect", { x: "1", y: "5", width: "13", height: "10", rx: "2", stroke: "currentColor", strokeWidth: "1.5" }), _jsx("path", { d: "M14 8.5l4.5-2.5v8l-4.5-2.5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}
function MicrophoneIcon() {
    return (_jsxs("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Add microphone", children: [_jsx("rect", { x: "7", y: "2", width: "6", height: "10", rx: "3", stroke: "currentColor", strokeWidth: "1.5" }), _jsx("path", { d: "M4 10a6 6 0 0012 0", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" }), _jsx("line", { x1: "10", y1: "16", x2: "10", y2: "18", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" })] }));
}
function ScreenShareIcon() {
    return (_jsxs("svg", { width: "20", height: "14", viewBox: "0 0 20 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Share screen", children: [_jsx("rect", { x: "1", y: "0.5", width: "18", height: "11", rx: "2", stroke: "currentColor", strokeWidth: "1.5" }), _jsx("path", { d: "M10 7V3.5M10 3.5L7.5 5.5M10 3.5l2.5 2", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("line", { x1: "6", y1: "13.25", x2: "14", y2: "13.25", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" })] }));
}
function InviteIcon() {
    return (_jsxs("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Invite speakers", children: [_jsx("circle", { cx: "10", cy: "10", r: "8", stroke: "currentColor", strokeWidth: "1.5" }), _jsx("path", { d: "M10 6.5v7M6.5 10h7", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" })] }));
}
function RemoteCameraIcon() {
    return (_jsxs("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Add remote camera", children: [_jsx("rect", { x: "1", y: "5", width: "13", height: "10", rx: "2", stroke: "currentColor", strokeWidth: "1.5" }), _jsx("path", { d: "M14 8.5l4.5-2.5v8l-4.5-2.5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("circle", { cx: "15", cy: "5", r: "4", fill: "currentColor", stroke: "currentColor", strokeWidth: "0.5" }), _jsx("path", { d: "M15 3v4M13 5h4", stroke: "#1a1a1a", strokeWidth: "1.2", strokeLinecap: "round" })] }));
}
function OgrafIcon() {
    return (_jsxs("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Add OGraf graphic", children: [_jsx("rect", { x: "2", y: "3", width: "16", height: "14", rx: "2", stroke: "currentColor", strokeWidth: "1.5" }), _jsx("path", { d: "M2 13h16", stroke: "currentColor", strokeWidth: "1.5" }), _jsx("rect", { x: "4", y: "14.5", width: "5", height: "1.5", rx: "0.75", fill: "currentColor" }), _jsx("rect", { x: "11", y: "14.5", width: "3", height: "1.5", rx: "0.75", fill: "currentColor", opacity: "0.6" })] }));
}
const PopupRoot = styled.div `
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 12px;
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.4);
    background: rgba(64, 64, 64, 0.3);
    backdrop-filter: blur(50px);
    width: 270px;
    box-sizing: border-box;
`;
const PopupItem = styled.div `
    position: relative;
    display: flex;
    align-items: center;
    height: 40px;
    padding: 0 12px;
    border-radius: 12px;
    cursor: pointer;
    overflow: hidden;
    transition: opacity 100ms ease;

    &:hover {
        opacity: 0.85;
    }

    &:active {
        opacity: 0.7;
    }
`;
const PopupItemBg = styled.div `
    position: absolute;
    inset: 0;
    border-radius: 12px;
    background: rgba(214, 214, 214, 0.45);
    mix-blend-mode: color-burn;
    pointer-events: none;

    &::after {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 12px;
        background: rgba(0, 0, 0, 0.3);
        mix-blend-mode: luminosity;
    }
`;
const PopupItemContent = styled.div `
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    color: #ededf2;
    font-family: 'Poppins', sans-serif;
    font-size: 15px;
    line-height: 22px;
    font-weight: 400;

    svg {
        flex-shrink: 0;
        width: 20px;
        height: 20px;
    }
`;
